import React from 'react';
import { Button } from '@mui/material';
import { Download } from '@mui/icons-material';

const EnzymeDownloadButton = ({ runId }) => {
  const handleDownload = () => {
    window.location.href = `/api/download/enzyme/${runId}/csv`;
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleDownload}
      startIcon={<Download />}
      sx={{ marginTop: 2 }}
    >
      Download Results (CSV)
    </Button>
  );
};

export default EnzymeDownloadButton; 